<template>
	<div class="detail-page">
		<div class="detail-page__header">
			<h2 class="detail-page__header-title">
				员工餐厅餐厨垃圾清运回收外包服务项目
			</h2>
			<p class="detail-page__header-time">发布时间：2021年05月12日</p>
		</div>
		<div class="detail-page__content">pagecontent</div>
		<div class="detail-page__footer">
			<div><span>上一篇：</span><span></span></div>
			<div><span>下一篇：</span><span></span></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {},
	data() {
		return {}
	},
	computed: {},
	created() {},
	mounted() {},
	watch: {},
	methods: {},
	components: {},
}
</script>

<style lang="scss"></style>
